import { createRouter, createWebHistory } from "vue-router";
const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/home.vue"),
  },
  {
    path: "/aviso-legal",
    name: "legalWarning",
    component: () => import("@/views/legalWarning.vue"),
    meta: {
      noindex: "noindex, nofollow",
    },
  },
  {
    path: "/politica-privacidad",
    name: "privatePolicy",
    component: () => import("@/views/privatePolicy.vue"),
    meta: {
      noindex: "noindex, nofollow",
    },
  },
  {
    path: "/politica-cookies",
    name: "cookiesPolicy",
    component: () => import("@/views/cookiesPolicy.vue"),
    meta: {
      noindex: "noindex, nofollow",
    },
  },
  {
    path: "/tus-datos-seguros",
    name: "yourDataSafe",
    component: () => import("@/views/yourDataSafe.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
  routes,
});

router.beforeEach((to, from, next) => {
  const robots = document.querySelector('meta[name="robots"]');
  if (!robots) return;
  if (to.meta.noindex) {
    robots.setAttribute("content", "noindex, follow");
  } else {
    robots.setAttribute("content", "index, follow");
  }

  next();
});

export default router;
